import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Cybersecurity = () => {
  const services = [
    {
      icon: FiIcons.FiShield,
      title: 'Protección Endpoint',
      description: 'Seguridad avanzada para todos sus dispositivos con Kaspersky Endpoint Security Cloud.'
    },
    {
      icon: FiIcons.FiLock,
      title: 'Firewall Gestionado',
      description: 'Configuración y gestión de firewalls para proteger su red empresarial.'
    },
    {
      icon: FiIcons.FiMail,
      title: 'Seguridad Email',
      description: 'Filtrado de spam y protección contra phishing y malware.'
    },
    {
      icon: FiIcons.FiActivity,
      title: 'Monitorización',
      description: 'Supervisión continua de amenazas y respuesta a incidentes.'
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">Ciberseguridad Gestionada</h1>

        <div className="mb-12">
          <p className="text-lg text-gray-600 mb-6">
            Proteja su empresa contra las amenazas cibernéticas con nuestras soluciones de seguridad gestionada, diseñadas para ofrecer una protección integral y continua.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg">
              <SafeIcon icon={service.icon} className="h-12 w-12 text-blue-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-red-50 p-8 rounded-lg mb-12">
          <h2 className="text-2xl font-semibold mb-4">Amenazas que prevenimos</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center">
              <SafeIcon icon={FiIcons.FiAlertTriangle} className="h-5 w-5 text-red-500 mr-3" />
              <span>Ransomware</span>
            </div>
            <div className="flex items-center">
              <SafeIcon icon={FiIcons.FiAlertTriangle} className="h-5 w-5 text-red-500 mr-3" />
              <span>Phishing</span>
            </div>
            <div className="flex items-center">
              <SafeIcon icon={FiIcons.FiAlertTriangle} className="h-5 w-5 text-red-500 mr-3" />
              <span>Malware</span>
            </div>
            <div className="flex items-center">
              <SafeIcon icon={FiIcons.FiAlertTriangle} className="h-5 w-5 text-red-500 mr-3" />
              <span>Ataques DDoS</span>
            </div>
          </div>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Cybersecurity;